exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".live-int-row{background-color:#000!important}.live-int-row span{color:orange!important}.row-error{background-color:red!important;color:#fff!important}.row-error span{color:#000!important}.live-table-column{overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
